import React, { useState, Fragment } from 'react';

const MountedTab = ({ 
    mark,
    mounted,
    mountedSpecs,
    spec,
    darkMode = false
}) => {
    const [expandedMountItems, setExpandedMountItems] = useState([]);
    const [expandedMountSpec, setExpandedMountSpec] = useState([]);

    // Функция для рекурсивного отображения спецификации монтажа
    const getMountExpandSpec = (spec, margin = 0, notMounted = []) => {
        if (!spec.complect || spec.complect.length === 0 || !expandedMountSpec || !expandedMountSpec.includes(spec.id)) return null;
        
        return spec.complect.map((c, y) => {
            let mass = (parseFloat(c.massa_1ed_kg) * parseFloat(c.count)).toString();
            mass = mass.includes('.') ? mass.split('.') : [mass];
            if (mass.length > 1) {
                mass[1] = mass[1].slice(0, 4);
            }

            const currentId = c.id?.toString();
            const isExactNotMounted = notMounted.some(chain =>
                chain === currentId || chain.endsWith('_' + currentId)
            );
            const isPartOfChain = !isExactNotMounted && notMounted.some(chain =>
                chain.startsWith(currentId + '_')
            );

            let backgroundColor = 'transparent';
            let textColor = 'text.primary';
            let indicator = '';

            if (isExactNotMounted) {
                backgroundColor = '#fff3cd';
                textColor = '#856404';
            } else if (isPartOfChain) {
                backgroundColor = '#fffbf0';
                textColor = '#b45309';
                indicator = '⚠ ';
            }

            return (
                <Fragment key={`mount_fragment_${spec.id}_${c.id || y}`}>
                    <tr key={`mount_${spec.id}_${c.id || y}`} style={{ backgroundColor, fontSize: '11px' }}>
                        <td
                            style={{
                                paddingLeft: `${margin}px`,
                                cursor: 'pointer',
                                color: textColor,
                                padding: '3px 6px'
                            }}
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                if (c.complect) {
                                    setExpandedMountSpec(prev => prev.includes(c.id) ? prev.filter(id => id !== c.id) : [...prev, c.id]);
                                }
                            }}
                        >
                            <b>{c.complect ? expandedMountSpec.includes(c.id) ? '− ' : '+ ' : ''}</b>
                            {indicator}{c.name}
                        </td>
                        <td style={{ color: textColor, padding: '3px 6px' }}>{c.type_marka_docs}</td>
                        <td style={{ color: textColor, padding: '3px 6px' }}>{c.factory_manufacturer}</td>
                        <td style={{ textAlign: 'center', color: textColor, padding: '3px 6px' }}>
                            {parseFloat(c.count).toString().replace('.', ',')} {c.unit}
                        </td>
                        <td style={{ textAlign: 'center', color: textColor, padding: '3px 6px' }}>
                            {mass.join(',')}
                        </td>
                    </tr>
                    {getMountExpandSpec(c, margin + 10, notMounted)}
                </Fragment>
            );
        });
    };

    if (!mounted || mounted.length === 0) {
        return (
            <div style={{ textAlign: 'center', color: '#666', fontSize: '14px', padding: '20px' }}>
                Данные о монтаже отсутствуют
            </div>
        );
    }

    const stageNames = {
        0: 'Не смонтировано',
        1: 'Частично смонтировано',
        2: 'Полностью смонтировано',
        3: 'Частично смонтировано(изменен тип)',
        4: 'Полностью смонтировано(изменен тип)'
    };

    const stageColors = {
        0: '#dc3545', // красный
        1: '#fd7e14', // оранжевый
        2: '#28a745',  // зеленый
        3: '#dd50dd', // светло-фиолетовый 
        4: '#8b008b'  // фиолетовый
    };

    return (
        <div style={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
            {mounted.map((mountItem, index) => {
                console.log(mountItem)
                const mountSpec = mountedSpecs?.[index];
                const isExpanded = expandedMountItems.includes(index);
                let status = mountItem.status
                if (status && status > 0 && mountItem.spec !== mark.spec) {
                    status = status + 2
                }

                return (
                    <div key={`mount_item_${index}`} style={{ marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                        <div
                            onClick={() => setExpandedMountItems(prev =>
                                prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                            )}
                            style={{
                                padding: '8px 12px',
                                cursor: 'pointer',
                                backgroundColor: '#f8f9fa',
                                borderBottom: isExpanded ? '1px solid #ddd' : 'none',
                                fontSize: '13px',
                                fontWeight: '500'
                            }}
                        >
                            <span style={{ marginRight: '8px' }}>
                                {isExpanded ? '▼' : '▶'}
                            </span>
                            <span style={{
                                color: stageColors[status] || '#495057',
                                fontWeight: '600'
                            }}>
                                {stageNames[status] || `Статус ${status}`}
                            </span>
                            <span style={{ color: '#495057' }}>
                                {' '} | {(() => {
                                    const date = new Date(mountItem.date);
                                    const time = date.toLocaleTimeString('ru-RU', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    });
                                    const dateStr = date.toLocaleDateString('ru-RU', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit'
                                    });
                                    return `${time} ${dateStr}`;
                                })()} |
                                {' '}{mountItem.user_name || 'Неизвестно'} |
                                {' '}{mountSpec?.name || 'Спецификация не найдена'}
                            </span>
                        </div>

                        {isExpanded && mountSpec && (
                            <div style={{ padding: '8px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', fontWeight: 'normal', marginBottom: '8px', fontSize: '12px', gap: '3px' }}>
                                    <span><b>{mountSpec.name}</b></span>
                                    <span style={{ color: '#444' }}>{mountSpec.category}</span>
                                </div>
                                
                                {mountItem.retreat && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '8px', padding: '6px', backgroundColor: '#f8f9fa', borderRadius: '3px', fontSize: '11px' }}>
                                        <strong>Обоснование:</strong> {mountItem.retreat}
                                        {spec?.name && mountSpec.name ? (
                                            <span style={{ color: '#444' }}>
                                                Спецификация изменена с <i><b>{spec.name}</b></i> на <i><b>{mountSpec.name}</b></i>
                                            </span>
                                        ) : null}
                                    </div>
                                )}

                                <table className="pillars04-popup-table" style={{ fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ borderTopLeftRadius: '3px', fontSize: '10px', padding: '4px' }}>Наименование</th>
                                            <th style={{ fontSize: '10px', padding: '4px' }}>Тип, марка</th>
                                            <th style={{ fontSize: '10px', padding: '4px' }}>Завод</th>
                                            <th style={{ fontSize: '10px', padding: '4px' }}>Кол-во</th>
                                            <th style={{ borderTopRightRadius: '3px', fontSize: '10px', padding: '4px' }}>Масса, кг</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mountSpec.complect_filtered?.map((cf, cfIndex) => {
                                            return (
                                                <Fragment key={`mount_cf_${index}_${cfIndex}`}>
                                                    {[{ type: cf.type }, ...cf.complect].map((c, i) => {
                                                        if (i === 0) {
                                                            return (
                                                                <tr key={`mount_header_${index}_${cfIndex}_${i}`}>
                                                                    <th colSpan={5} style={{ fontSize: '10px', padding: '3px', backgroundColor: '#e9ecef' }}>{c.type}</th>
                                                                </tr>
                                                            );
                                                        }
                                                        
                                                        let mass = (parseFloat(c.massa_1ed_kg) * parseFloat(c.count)).toString();
                                                        mass = mass.includes('.') ? mass.split('.') : [mass];
                                                        if (mass.length > 1) {
                                                            mass[1] = mass[1].slice(0, 4);
                                                        }
                                                        
                                                        const currentId = c.id?.toString();
                                                        
                                                        // Получаем массив не смонтированных элементов из state
                                                        // В новом формате state - это объект, где ключи - ID элементов, а значения - объекты с selected, date, userid
                                                        let state = mountItem.state || {};
                                                       
                                                        const notMountedArray = Object.entries(state)
                                                            .filter(([itemId, itemData]) => {
                                                                // Элемент не смонтирован, если selected === false или отсутствует
                                                                return itemData && typeof itemData === 'object' && itemData.selected === false;
                                                            })
                                                            .map(([itemId]) => itemId);

                                                        if (!currentId) return null;

                                                        // Проверяем является ли элемент конечным в любой цепочке (заканчивается на _currentId или равен currentId)
                                                        const isExactNotMounted = notMountedArray.some(chain =>
                                                            chain === currentId || chain.endsWith('_' + currentId)
                                                        );
                                                        // Проверяем является ли элемент частью цепочки (только если НЕ является конечным)
                                                        const isPartOfChain = !isExactNotMounted && notMountedArray.some(chain =>
                                                            chain.startsWith(currentId + '_')
                                                        );

                                                        let backgroundColor = 'transparent';
                                                        let textColor = 'inherit';
                                                        let indicator = '';

                                                        if (isExactNotMounted) {
                                                            // Конечный элемент - полностью оранжевый
                                                            backgroundColor = '#fff3cd';
                                                            textColor = '#856404';
                                                        } else if (isPartOfChain) {
                                                            // Промежуточный элемент цепочки - легкий оранжевый фон и индикатор
                                                            backgroundColor = '#fffbf0';
                                                            textColor = '#b45309';
                                                            indicator = '⚠ ';
                                                        }

                                                        return (
                                                            <Fragment key={`mount_item_fragment_${index}_${cfIndex}_${i}`}>
                                                                <tr key={`mount_row_${index}_${cfIndex}_${i}`} style={{
                                                                    backgroundColor,
                                                                    fontSize: '11px'
                                                                }}>
                                                                    <td
                                                                        onClick={(event) => {
                                                                            event.preventDefault();
                                                                            event.stopPropagation();
                                                                            if (c.complect) {
                                                                                setExpandedMountSpec(prev => prev.includes(c.id) ? prev.filter(id => id !== c.id) : [...prev, c.id]);
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            color: textColor,
                                                                            padding: '3px 6px'
                                                                        }}
                                                                    >
                                                                        <b>{c.complect ? expandedMountSpec.includes(c.id) ? '− ' : '+ ' : ''}</b>{indicator}{c.name}
                                                                    </td>
                                                                    <td style={{ color: textColor, padding: '3px 6px' }}>{c.type_marka_docs}</td>
                                                                    <td style={{ color: textColor, padding: '3px 6px' }}>{c.factory_manufacturer}</td>
                                                                    <td style={{ textAlign: 'center', color: textColor, padding: '3px 6px' }}>
                                                                        {parseFloat(c.count).toString().replace('.', ',')} {c.unit}
                                                                    </td>
                                                                    <td style={{ textAlign: 'center', color: textColor, padding: '3px 6px' }}>
                                                                        {mass.join(',')}
                                                                    </td>
                                                                </tr>
                                                                {getMountExpandSpec(c, 10, notMountedArray)}
                                                            </Fragment>
                                                        );
                                                    })}
                                                </Fragment>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MountedTab;
